<h1 mat-dialog-title>Account Delinquency Restriction</h1>
<div mat-dialog-content>
  <p>Your application usage is restricted because of account delinquency.</p>
  @if (!isOrgBillingAdminUser) {
    <p>Contact your Organization Billing Admin to resolve your account's status.</p>
  }

  @if (isOrgBillingAdminUser) {
    <button mat-raised-button color="primary" class="mb-1" routerLink="/manage/billing" mat-dialog-close>
      Pay Delinquent Invoice(s)
    </button>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close('OK')" type="submit" color="accent">OK</button>
</div>
